import { MainProduct, PendantProduct } from "../../../types"

// @TODO: Remove when titles are nice OR when a separate label field is added to metafileds
const formatTitle = (title: string) => {
  return title.split('] [')[1].replace(']', '')
}

export const getPendantGroupTabs = (
  mainProduct: MainProduct, 
  setActivePendantProductId: (activePendantProductId: string) => void
) => {
  const tabs = mainProduct.metafields.pendantProducts.map(({ id, title }) => ({
    value: id,
    label: formatTitle(title),
    onClick: () => setActivePendantProductId(id)
  }))

  return tabs
}

export const getPendantProductById = (
  mainProduct: MainProduct, 
  id: string
) => {
  const { metafields: { pendantProducts } } = mainProduct
  return pendantProducts.find(pendantProduct => pendantProduct.id === id)!
}

export const getPendantProductVariantsByMaterial = (
  pendantProduct: PendantProduct, 
  material: string
) => {
  const materialOptionIndex = pendantProduct.optionsWithValues
    .find((optionWithValues) => optionWithValues.name === "Metal")!
    .position - 1

  const pendantProductVariantsByMaterial = pendantProduct.variants
    .filter(pendantProductVariant => pendantProductVariant.options[materialOptionIndex] === material)

  return pendantProductVariantsByMaterial
}